import { Component, Input, ElementRef, ViewChild, AfterViewInit, OnDestroy, OnInit } from '@angular/core';
import { FadeIn, Fade } from '../animations/animations';
import { AbstractTable } from './utility/context/abstract/table.class';
import { Toggler } from '../utils/toggler.class';


@Component({
   selector: 'exi-table',
   templateUrl: './table.component.html',
   styleUrls: ['./table.component.scss'],
   animations: [Fade, FadeIn,
        
   ]
})
export class TableComponent<D extends object> implements OnInit, AfterViewInit, OnDestroy {
   @Input() public ctx: AbstractTable<D>;
   @ViewChild('Wrapper') private wrapper: ElementRef<HTMLDivElement>;
   @ViewChild('Header') private header: ElementRef<HTMLDivElement>;
   @ViewChild('Body') private body: ElementRef<HTMLDivElement>;
  


   public toggler = new Toggler();
   public browser = navigator.appVersion.includes(`Chrome`) ? 'chrome' : '';

   constructor(
      private hostRef: ElementRef<HTMLDivElement>,
   ) { }

   
   ngOnInit() {

   }


   ngAfterViewInit() {
      requestAnimationFrame(() => {
         this.ctx.dom.wrapper = this.wrapper.nativeElement;
         this.ctx.dom.header = this.header.nativeElement;
         this.ctx.dom.body = this.body.nativeElement;
         this.ctx.dom.host = this.hostRef.nativeElement;
         this.ctx.dom.isAlive.next(true);
      });
   }


   ngOnDestroy() {
      this.ctx.dom.isAlive.next(false);
   }


   toggleMenu(e: MouseEvent) {
      e.preventDefault();
      this.ctx.menu.toggler.toggle();
   }

}
